import React from "react";

const ConfirmModal = ({ closeConfirm }) => {
    return (
        <div className="ConfirmModal">
            <div className="modal fade" id="DirConfirmModal" tabIndex="-1" role="dialog" aria-labelledby="DirectoryConfirmationModal" aria-hidden="false" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title" id="myModalLabel"> Confirmed </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeConfirm} > <span aria-hidden="false">&times;</span> </button>
                        </div>
                        <div className="modal-body">

                            <div className="bi-success-check">
                              <i className="bi bi-check2-circle" alt="Success Checkmark"></i>
                            </div>

                            <div className="message-wrapper">
                              Member has been added successfully to your contact list in
                              webmail.
                            </div>
                            {/*<div className="md-msg" hidden>*/}

                            {/*  ---location - Organization Details under Certificates--- A TLS*/}
                            {/*  Certificate was successfully created.*/}
                            {/*</div>*/}
                            {/*<div className="md-msg" hidden>*/}

                            {/*  ---location - Organization Details under Certificates---*/}
                            {/*  Unchecking this option will delete current CSR-based certificate*/}
                            {/*  and default back to TLS Certificate from this organization.*/}
                            {/*</div>*/}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" data-dismiss="modal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ConfirmModal;
